import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplitManagerService {
  dragGutterEmitter = new EventEmitter<any>();
}
